// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.f5zajoYJE_pjMFCdAsx4 {
  height: 50vh;
  min-height: 400px;
  width: 100%;
}

.sCc6Ok56nibI8IG33Bbg {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
}`, "",{"version":3,"sources":["webpack://./src/screens/VaultAdministration/VaultChart.module.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,iBAAA;EACA,WAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,aAAA;AACJ","sourcesContent":[".chartContainer {\r\n    height: 50vh;\r\n    min-height: 400px;\r\n    width: 100%;\r\n}\r\n\r\n.chartsContainer {\r\n    display: flex;\r\n    flex-direction: column;\r\n    row-gap: 16px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chartContainer": `f5zajoYJE_pjMFCdAsx4`,
	"chartsContainer": `sCc6Ok56nibI8IG33Bbg`
};
export default ___CSS_LOADER_EXPORT___;
